/**
 * API Configuration
 * 
 * Dinamik olarak backend URL'sini belirler:
 * - Production'da: Mevcut domain'i kullanır (window.location.origin)
 * - Development'ta: REACT_APP_BACKEND_URL env variable'ı kullanır
 * 
 * Bu sayede frontend hangi domain'de çalışırsa çalışsın,
 * API çağrıları otomatik olarak doğru URL'ye gider.
 */

import axios from 'axios';

// Development modunda mı çalışıyoruz?
const isDevelopment = process.env.NODE_ENV === 'development';

// Backend URL'sini belirle
const getBackendUrl = () => {
  if (isDevelopment) {
    const direct = (process.env.REACT_APP_BACKEND_URL || '').trim();
    const forceDirect = process.env.REACT_APP_USE_DIRECT_BACKEND === 'true';
    const forceProxy = process.env.REACT_APP_USE_DIRECT_BACKEND === 'false';

    // Default: webpack dev-server proxy (/api -> :8011) — no CORS
    if (forceProxy) return '';
    if (forceDirect && direct) return direct.replace(/\/$/, '');
    if (direct && (direct.includes(':8011') || direct.includes('127.0.0.1'))) {
      return '';
    }
    if (direct) return direct.replace(/\/$/, '');
    return '';
  }

  // Production'da mevcut origin
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }

  return (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
};

// Singleton pattern - URL'yi bir kez hesapla
export const API_BASE_URL = getBackendUrl();

// Alias for backward compatibility
export const BACKEND_URL = API_BASE_URL;

// Helper function to build full API URLs
export const buildApiUrl = (endpoint) => {
  const base = API_BASE_URL;
  // Endpoint zaten /api ile başlıyorsa, direkt ekle
  if (endpoint.startsWith('/api')) {
    return `${base}${endpoint}`;
  }
  // Değilse /api prefix'i ekle
  return `${base}/api${endpoint.startsWith('/') ? endpoint : '/' + endpoint}`;
};

// Request interceptor - send cookies + bearer token on cross-origin dev requests
axios.interceptors.request.use(
  (config) => {
    if (isDevelopment) {
      config.withCredentials = true;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      const skipRedirect =
        error.config?.skipAuthRedirect === true ||
        url.includes('/api/copyright/auto-match/status') ||
        url.includes('/api/auth/me') ||
        // SMTP auth failures used to return 401 and wrongly kicked admins to login
        url.includes('/api/mail/test') ||
        url.includes('/api/mail/send');

      const currentPath = window.location.pathname;
      if (!skipRedirect && !currentPath.includes('/login')) {
        localStorage.removeItem('auth_user');
        localStorage.removeItem('auth_token');
        sessionStorage.removeItem('auth_session_token');
        if (currentPath.includes('/admin') || currentPath.includes('/dashboard')) {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default API_BASE_URL;
